// extracted by mini-css-extract-plugin
export var actionIcon = "_r5-0";